var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-instagram",
    transform: "translate(-1162 -158)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_white",
    "data-name": "Ellipse white",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(1162 158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_grey",
    "data-name": "Ellipse grey",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(1164 160)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_011-instagram",
    "data-name": "011-instagram",
    transform: "translate(1164 160)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1296",
    "data-name": "Path 1296",
    d: "M211.977,209.488A2.488,2.488,0,1,1,209.488,207,2.488,2.488,0,0,1,211.977,209.488Zm0,0",
    transform: "translate(-196.488 -196.488)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1297",
    "data-name": "Path 1297",
    d: "M147.424,137.206a2.472,2.472,0,0,0-1.417-1.417,4.13,4.13,0,0,0-1.386-.257c-.787-.036-1.023-.044-3.017-.044s-2.229.008-3.017.043a4.133,4.133,0,0,0-1.386.257,2.473,2.473,0,0,0-1.417,1.417,4.132,4.132,0,0,0-.257,1.386c-.036.787-.044,1.023-.044,3.017s.008,2.229.044,3.017a4.13,4.13,0,0,0,.257,1.386,2.472,2.472,0,0,0,1.417,1.417,4.125,4.125,0,0,0,1.386.257c.787.036,1.023.043,3.016.043s2.23-.008,3.017-.043a4.125,4.125,0,0,0,1.386-.257,2.472,2.472,0,0,0,1.417-1.417,4.134,4.134,0,0,0,.257-1.386c.036-.787.043-1.023.043-3.017s-.008-2.229-.043-3.017A4.125,4.125,0,0,0,147.424,137.206Zm-5.819,8.236a3.833,3.833,0,1,1,3.833-3.833A3.833,3.833,0,0,1,141.6,145.441Zm3.985-6.922a.9.9,0,1,1,.9-.9A.9.9,0,0,1,145.589,138.519Zm0,0",
    transform: "translate(-128.604 -128.608)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1298",
    "data-name": "Path 1298",
    d: "M13,0A13,13,0,1,0,26,13,13,13,0,0,0,13,0Zm7.42,16.078a5.477,5.477,0,0,1-.347,1.812,3.817,3.817,0,0,1-2.183,2.183,5.481,5.481,0,0,1-1.812.347c-.8.036-1.05.045-3.078.045s-2.282-.009-3.078-.045a5.481,5.481,0,0,1-1.812-.347A3.817,3.817,0,0,1,5.927,17.89a5.475,5.475,0,0,1-.347-1.812c-.037-.8-.045-1.051-.045-3.078s.009-2.282.045-3.078A5.477,5.477,0,0,1,5.927,8.11,3.82,3.82,0,0,1,8.11,5.927,5.482,5.482,0,0,1,9.922,5.58c.8-.036,1.05-.045,3.078-.045s2.282.009,3.078.045a5.483,5.483,0,0,1,1.812.347A3.818,3.818,0,0,1,20.073,8.11a5.476,5.476,0,0,1,.347,1.812c.036.8.045,1.05.045,3.078S20.456,15.282,20.42,16.078Zm0,0",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.b5d4156ff4a85757e13c321417e9b7f0.svg";
export { ForwardRef as ReactComponent };